import { Container, Reveal, Section, SectionHead } from '@nexa/ui';
import { useCopy } from '@/core/i18n';
import { KnowledgeCard } from './KnowledgeCard.tsx';

/**
 * `#knowledge` — `template.html:947`.
 *
 * `id="knowledge"` nằm trong `SPY_IDS`, và `NAV_ALIASES` gộp nó vào `ai` ⇒ mục nav "AI" sáng cho
 * cả hai section. Đó là thiết kế, không phải lỗi.
 *
 * `headingSize="h2-compact"`: thiết kế đo h2 38px (`:951`), và `tokens.css` có bậc riêng cho 38.
 *
 * KHÔNG truyền `lead`: khối đầu của section này chỉ có eyebrow + h2 (`:949-952`).
 * KHÔNG truyền `leadTone`: mặc định `ink-600` đã đúng.
 *
 * Hai cột chỉ từ `xl` — `reference.md` §2 hàng 8 ghi `md` đã là 1 cột.
 */
export function KnowledgeSection() {
  const copy = useCopy();

  return (
    <Section
      id="knowledge"
      labelledBy="knowledge-heading"
      cv
      // Mồi content-visibility khai theo bậc trong `packages/ui/src/motion.css`, không ở đây.
      className="nx-cv-knowledge"
    >
      <Container>
        <Reveal>
          <SectionHead
            id="knowledge-heading"
            eyebrow={copy.knowledge.eyebrow}
            heading={copy.knowledge.heading}
            maxWidth="56ch"
            headingSize="h2-compact"
          />
        </Reveal>

        <div className="mt-[38px] grid gap-5 xl:grid-cols-2">
          {copy.knowledge.cards.map((card) => (
            <Reveal key={card.title} className="h-full">
              <KnowledgeCard {...card} betaLabel={copy.knowledge.betaLabel} />
            </Reveal>
          ))}
        </div>
      </Container>
    </Section>
  );
}
